import React from 'react';
import { cn } from '../../../../../utils/tailwind';

interface TextFieldWithSliderWrapperProps {
    children: React.ReactNode;
    className?: string;
}

export const TextFieldWithSliderWrapper: React.FC<TextFieldWithSliderWrapperProps> = ({ children, className }) => (
    <div
        className={cn(
            'flex flex-col gap-[0.5rem] [&_.MuiInputAdornment-root]:!w-auto [&_.MuiInputAdornment-root]:!min-w-0 [&_.MuiInputAdornment-root]:!max-w-none [&_.MuiInputBase-input]:!min-w-0 [&_.MuiInputBase-input]:!w-auto [&_.MuiInputBase-input]:!flex-1',
            className,
        )}
    >
        {children}
    </div>
);
